
import { useState, useEffect } from 'react';
import ProductManager from './components/ProductManager';
import StockManager from './components/StockManager';
import OrdersView from './components/OrdersView';
import NewsletterManager from './components/NewsletterManager';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState('products');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

  const adminPassword = 'admin123'; // En producción esto debería estar en variables de entorno

  useEffect(() => {
    const auth = localStorage.getItem('admin_auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === adminPassword) {
      setIsAuthenticated(true);
      localStorage.setItem('admin_auth', 'true');
    } else {
      alert('Contraseña incorrecta');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('admin_auth');
    setPassword('');
  };

  const handleProductUpdate = () => {
    // Callback para actualizar datos cuando se modifiquen productos
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="bg-gray-900 p-8 rounded-lg border border-gray-700 w-full max-w-md">
          <h1 className="text-3xl font-bold text-white mb-6 text-center" style={{ fontFamily: '"Playfair Display", serif' }}>
            Panel de Administración
          </h1>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Contraseña de administrador
              </label>
              <input 
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-[#C6A45C] focus:outline-none transition-colors duration-300"
                placeholder="Ingresa la contraseña"
                required
              />
            </div>
            <button 
              type="submit"
              className="w-full bg-[#C6A45C] text-white py-3 rounded-lg hover:bg-[#B8954F] transition-all duration-300 font-medium whitespace-nowrap"
            >
              Ingresar
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="bg-gray-900 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-2xl font-bold text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
              Panel de Administración - Perra Luxury
            </h1>
            <button 
              onClick={handleLogout}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-all duration-300 whitespace-nowrap"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </header>

      {/* Navigation Tabs */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            <button 
              onClick={() => setActiveTab('products')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 whitespace-nowrap ${
                activeTab === 'products' 
                  ? 'border-[#C6A45C] text-[#C6A45C]' 
                  : 'border-transparent text-gray-400 hover:text-white hover:border-gray-300'
              }`}
            >
              Gestión de Productos
            </button>
            <button 
              onClick={() => setActiveTab('stock')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 whitespace-nowrap ${
                activeTab === 'stock' 
                  ? 'border-[#C6A45C] text-[#C6A45C]' 
                  : 'border-transparent text-gray-400 hover:text-white hover:border-gray-300'
              }`}
            >
              Control de Stock
            </button>
            <button 
              onClick={() => setActiveTab('orders')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 whitespace-nowrap ${
                activeTab === 'orders' 
                  ? 'border-[#C6A45C] text-[#C6A45C]' 
                  : 'border-transparent text-gray-400 hover:text-white hover:border-gray-300'
              }`}
            >
              Pedidos
            </button>
            <button 
              onClick={() => setActiveTab('newsletter')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 whitespace-nowrap ${
                activeTab === 'newsletter' 
                  ? 'border-[#C6A45C] text-[#C6A45C]' 
                  : 'border-transparent text-gray-400 hover:text-white hover:border-gray-300'
              }`}
            >
              Newsletter
            </button>
          </nav>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'products' && <ProductManager onProductAdded={handleProductUpdate} />}
        {activeTab === 'stock' && <StockManager />}
        {activeTab === 'orders' && <OrdersView />}
        {activeTab === 'newsletter' && <NewsletterManager />}
      </main>
    </div>
  );
}
